import React, { useState, useEffect, useCallback, useContext } from "react";
import { Link, useHistory, useRouteMatch, useLocation } from "react-router-dom";
import { useJoinGame } from "../../hooks/useJoinGame";
import { useCreateGame } from "../../hooks/useCreateGame";
import Button from "../button";
import Logo from "../../assets/images/holiday-logo.png";
import Snowglobe from "../../assets/images/snowglobe.png";
import SnowglobeDesktop from "../../assets/images/snowglobe-desktop.png";
import SnowBg from "../../assets/images/snow-bg.svg";

import Sunburst from "../../assets/images/sunburst.svg";
import { motion } from "framer-motion";
import JoinGameErrorModal from "../modal/joinErrorModal";
import { MAX_QUESTION_SETS } from "../../config";
import { characterData } from "../character-picker";
import "./main.scss";
import { UserContext } from "../UserContext";
import useWindowSize from "react-use/lib/useWindowSize";
import starBg from "../../assets/images/star-pattern.svg";

declare const window: any;
interface Props {
  bindTracking: Function;
}

const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1
  },
  exit: {
    opacity: 0,
    transition: {
      ease: "easeInOut"
    }
  }
};

const Main = (props: Props) => {
  const { width, height } = useWindowSize();

  useEffect(() => {
    window.bindTracking({
      data: {
        pageviewevent: "1",
        screenName: "Lander",
        screenSection: "Lander",
        interactionName: "Lander"
      }
    });

    characterData.forEach(character => {
      const img = new Image();
      img.src = character.imageSrc;
    });

    const bg = new Image();
    bg.src = starBg;
  }, []);

  const history = useHistory();

  const goToGame = useCallback(
    (gameId: string) => {
      history.push(`/game/${gameId}`);
    },
    [history]
  );

  const { user } = useContext(UserContext);

  //set a random question set
  let gameQuestionSet: number = Math.floor(Math.random() * MAX_QUESTION_SETS);

  const [joinGame, joinGameStatus] = useJoinGame(user.id, user.name);
  const [createGame, createGameStatus] = useCreateGame(
    user.id,
    user.name,
    gameQuestionSet
  );

  useEffect(() => {
    const { called, loading, data } = joinGameStatus;
    if (called && !loading && data) {
      goToGame(data);
    }
  }, [joinGameStatus, goToGame]);

  useEffect(() => {
    const { called, loading, data } = createGameStatus;
    if (called && !loading && data) {
      goToGame(data);
    }
  }, [createGameStatus, goToGame, gameQuestionSet]);

  const buttonContainer = {
    hidden: { opacity: 1 },
    show: {
      opacity: 1,
      transition: {
        delayChildren: 0.4,
        staggerChildren: 0.15
      }
    }
  };

  const item = {
    hidden: { opacity: 0, y: 25 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        ease: "backOut"
      }
    }
  };
  function triggerEvent(cb: Function, interactionName: string) {
    window.bindTracking({
      type: "interaction-event",
      data: {
        interactionEvent: 1,
        screenName: "Lander",
        screenSection: "Lander",
        interactionName
      }
    });
    cb();
  }

  return (
    <>
      <div className="landing-page">
        <motion.div
          initial="hidden"
          animate="visible"
          exit="exit"
          variants={containerVariants}
          className="show-art"
        >
          <motion.img
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ type: "tween", duration: 0.65, ease: "backOut" }}
            exit={{ opacity: 0, scale: 0 }}
            src={Logo}
            className="show-title"
            alt="American Dad Trivia: Head to Head"
            style={{ maxHeight: height * 0.6 }}
          />
          <motion.img
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ type: "tween", duration: 0.65, ease: "backOut" }}
            exit={{ opacity: 0, scale: 0 }}
            src={Snowglobe}
            className="snowglobe"
            alt="American Dad Trivia: Head to Head"
            style={{ maxHeight: height * 0.7 }}
          />
          <motion.img
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ type: "tween", duration: 0.65, ease: "backOut" }}
            exit={{ opacity: 0, scale: 0 }}
            src={SnowglobeDesktop}
            className="snowglobe-desktop"
            alt="American Dad Trivia: Head to Head"
            // style={{ maxHeight: height * 0.7 }}
          />
          <motion.div
            variants={buttonContainer}
            initial="hidden"
            animate="show"
            exit={{ opacity: 0, scale: 0 }}
            className="button-group"
          >
            <motion.div variants={item} className="join-game">
              <Button
                color="green"
                onClick={() => triggerEvent(joinGame, "Join A Game")}
              >
                Join a Game
              </Button>
            </motion.div>
            <motion.div variants={item} className="create-game" onClick={() => triggerEvent(createGame, "Start A Game")}>
              <Button
                color="red"
                
              >
                Create a Game
              </Button>
            </motion.div>
          </motion.div>
        </motion.div>
        <img className="snow-bg" src={SnowBg} alt=""/>
        <div
          className="sunburst"
          style={{ backgroundImage: `url(${Sunburst})` }}
        ></div>
      </div>

      <JoinGameErrorModal
        hideClose={true}
        errorMsg={joinGameStatus.error}
        joinGame={() => triggerEvent(joinGame, "Join A Game")}
        createGame={() => triggerEvent(createGame, "Start A Game")}
      />
    </>
  );
};
export default Main;
